"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SeatMapPreview = void 0;
var tslib_1 = require("tslib");
var overlay_1 = require("./overlay");
var framebus_1 = tslib_1.__importDefault(require("framebus"));
var FRAMEBUS_CHANNEL = 'seatMapPreview';
var SeatMapPreview = (function () {
    function SeatMapPreview(options) {
        this.container = null;
        this.iframe = null;
        this.areaId = null;
        this.overlay = null;
        this.bus = null;
        this.selectedSeats = [];
        this.onLoaded = function (data, reply) { };
        this.options = options;
    }
    SeatMapPreview.prototype.initializeBusFrame = function () {
        var _this = this;
        if (this.bus) {
            throw new Error('could not initialize Framebus.');
        }
        this.bus = SeatMapPreview.createBus();
        this.bus.on('loaded', this.onLoaded);
        this.bus.on('loaded', function () {
            if (_this.overlay) {
                _this.overlay.hide();
            }
        });
    };
    SeatMapPreview.prototype.destroyBusFrame = function () {
        if (this.bus) {
            this.bus.off('loaded', this.onLoaded);
            this.bus.teardown();
        }
    };
    Object.defineProperty(SeatMapPreview.prototype, "url", {
        get: function () {
            if (!this.areaId) {
                throw new Error('areaId is not defined');
            }
            var baseUrl = this.options.url.replace(/\/$/, '');
            var qs = [];
            qs.push("areaId=" + this.areaId);
            if (this.options.defaultSeatStyle) {
                qs.push("defaultSeatStyle=" + encodeURIComponent(JSON.stringify(this.options.defaultSeatStyle)));
            }
            if (this.options.selectedSeatStyle) {
                qs.push("selectedSeatStyle=" + encodeURIComponent(JSON.stringify(this.options.selectedSeatStyle)));
            }
            return baseUrl + "/seatMapPreview?" + qs.join('&');
        },
        enumerable: false,
        configurable: true
    });
    SeatMapPreview.prototype.createIframe = function (url) {
        if (window == undefined) {
            throw new Error('error related to browser compatibility');
        }
        if (this.iframe) {
            this.destroy();
        }
        this.container = document.querySelector(this.options.container);
        if (!this.container) {
            throw new Error("Could not find element with selector : " + this.options.container);
        }
        this.container.style.width = this.options.width + "px";
        this.container.style.height = this.options.height + "px";
        this.iframe = window.document.createElement("iframe");
        if (this.options.width) {
            this.iframe.setAttribute('width', this.options.width.toString());
        }
        else {
            this.iframe.setAttribute('width', '100%');
        }
        if (this.options.height) {
            this.iframe.setAttribute('height', this.options.height.toString());
        }
        this.iframe.setAttribute('scrolling', 'no');
        this.iframe.setAttribute('src', url);
        this.overlay = new overlay_1.Overlay(this.container);
        this.container.appendChild(this.iframe);
    };
    SeatMapPreview.prototype.load = function (areaId) {
        this.areaId = areaId;
        this.createIframe(this.url);
        this.initializeBusFrame();
    };
    SeatMapPreview.prototype.destroy = function () {
        this.destroyBusFrame();
        if (this.iframe) {
            this.iframe.remove();
            this.iframe = null;
        }
        if (this.overlay) {
            this.overlay.destroy();
        }
    };
    SeatMapPreview.createBus = function () {
        return new framebus_1.default({
            channel: FRAMEBUS_CHANNEL
        });
    };
    return SeatMapPreview;
}());
exports.SeatMapPreview = SeatMapPreview;
//# sourceMappingURL=SeatMapPreview.js.map